<div *ngIf="entity">
  <h2>{{ viewContext.entityNamePlural | titlecase}} / {{ entity.name | uppercase }}</h2>

  <div>
    <form (ngSubmit)="onSubmit()" [formGroup]="form">

      <div *ngFor="let question of questions" class="form-row">
        <div class="form-group col-xl-10">
          <app-question [question]="question" [form]="form"></app-question>
        </div>
      </div>
    </form>
  </div>

  <qm-rights-of-group *ngIf="!isNew()"
                       [userRightsGroupUis]="userRightsGroupUis"
                       [groupId]="getIdFromUrl()">
  </qm-rights-of-group>

  <app-buttons [buttons]="getButtonsMeta()"
               (buttonPressed)="controlButtonPressed($event)"
               [targetSelected]="true">
  </app-buttons>

</div>
